var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isShow)?_c('div',{staticClass:"crm-fix-msg"},[_c('em',{staticClass:"iconfont",class:_vm.status == 'success' ? 'green' : 'red'},[_vm._v(_vm._s(_vm.status == 'success' ? '' : ''))]),_vm._v(" "+_vm._s(_vm.text)+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }